<template>
    <div class="livingVideoView">
        <div class="video-player flex-start flex-top">
            <div class="left">
                <div class="video-box flex-center" :style="'height:'+ (isrecommendview?536:674) + 'px;width:'+ (isrecommendview?954:1200) + 'px'">
                    <video :src="item.csfileurl" oncontextmenu="return false;" class="video" controls></video>
                </div>
                <div class="oper flex-between fs-12">
                    <div class="left_actions flex-start">
                      <img class="coverurl" @click="goVideoList" :src="item.coverurl" alt="">
                      <span class="hostname">{{item.hostname}}</span>
                      <el-button type="primary" @click="uploadCourseHostFollow">{{item.isfavoritehost === 0 ? '关注' : '取消关注'}}</el-button>
                    </div>
                    <div class="right_actions flex-start">
                      <el-popover :visible-arrow="false" popper-class="appPopover" placement="bottom" width="110" trigger="hover">
                        <div class="appCode">
                          <img :src="require('@/common/images/other/app_code.png')" alt="">
                          <p>扫码下载APP</p>
                        </div>
                        <div class="appTips" slot="reference">
                          <img class="phone" :src="require('@/common/images/other/phone.png')" alt="">
                          APP下载
                        </div>
                      </el-popover>
                      <span class="separate">|</span>
                      <div class="box zan icon-zan flex-center pointer" :class="[item.ispraise==1?'select':'']" @click="handleZan">{{item.praisecount}}</div>
                      <div class="box collect icon-collect flex-center pointer" :class="[item.isfavorite==1?'select':'']" @click="handleCollect">{{item.favoritedcount}}</div>
                      <div class="box comment icon-comment flex-center pointer" :class="[item.comentcount>0?'select':'']" @click="handleComment">{{item.comentcount}}</div>
                      <span class="separate">|</span>
                      <el-popover placement="bottom" width="425" trigger="hover" popper-class="share-box" v-model="isPopView">
                          <div class="share pointer"  slot="reference">
                              <i class="box flex-center icon-share"  :class="[isPopView?'select':'']"></i>
                          </div>
                          <div class=" flex-between">
                              <div class="left flex-grow">
                                  <div class="flex-start"><span>分享到社交媒体：</span><i class="icon icon-webo"></i></div>
                                  <div class="" style="margin: 12px 0;">分享视频地址：</div>
                                  <div class="flex-start">
                                      <el-input v-model="qrcode.url" class="fs-12" :disabled="true"></el-input>
                                      <input id="input" v-model="qrcode.url" style="position: absolute;opacity: 0;z-index:-10;"/>
                                      <el-button type="primary" @click="handleCopy(qrcode.url)">复制</el-button>
                                  </div>
                              </div>
                              <div class="right">
                                  <div class="fs-12 tc">分享到微信</div>
                                  <div class="img-box"><img v-lazy="qrcode.base64" alt="" class="img"></div>
                              </div>
                          </div>
                      </el-popover>
                    </div>
                </div>
                <div class="close-btn pointer" @click="handleClose" v-show="!isrecommendview"></div>
            </div>
            <div class="right" ref="recommend" v-if="recommendlist.length">
                <div class="recommend-box">
                    <div class="title tc-write fs-18">推荐视频</div>
                    <!--<happy-scroll color="rgba(0,0,0,0.5)" size="5" resize @vertical-end="load" :scroll-top.sync="scrtop">-->
                        <div class="list">
                            <div class="box pointer" v-for="(obj,i) in recommendlist" :key="i" @click="handleClick(obj)">
                                <div class="img-box"><img class="img" v-lazy="obj.coverurl" alt=""></div>
                                <div class="tc-write text-ellipses subject fs-14">{{obj.subject}}</div>
                            </div>
                        </div>
                    <!--</happy-scroll>-->
                    <div class="close-btn pointer" @click="handleClose" v-show="isrecommendview"></div>
                    <div class="load-more fs-14 tc-write tc pointer" @click="handleMore">查看更多</div>
                </div>
            </div>
        </div>
        <div class="intro">
            <div class="subject fs-20">{{item.subject}}</div>
            <div class="desc fs-16 tc-gray" v-html="item.description"></div>
            <div class="datetime tc-grey fs-14">发布于：{{item.datetime}}</div>
        </div>
        <div class="living-container join-box">
            <div class="title fs-20">参与讨论</div>
            <div class="content-box fs-14">
                <el-input type="textarea" :rows="7" placeholder="登录后才能参与讨论哦..." v-model="content" class="textarea" maxlength="300"></el-input>
                <div class="oper flex-between">
                    <div class="flex-grow flex-between left">
                        <div class="tc-gray" v-if="!user.isLogin"><span class="tc-blue pointer" @click="openLogin">登录</span>后参与讨论</div>
                        <div class="tc-gray" v-if="user.isLogin">请回复有价值的信息，无意义的评论将很快被删除，账号将被禁止发言。</div>
                        <div class="tc-grey">{{content.length}}/300</div>
                    </div>
                    <div class="btn tc-write tc pointer" @click="handleAdd">发表评论</div>
                </div>
            </div>
        </div>
        <div class="living-container comment-box" v-if="commentlist.length" ref="comment">
            <div class="title fs-20">评论区</div>
            <happy-scroll color="rgba(0,0,0,0.5)" size="5" resize @vertical-end="load" :scroll-top.sync="scrtop">
            <div class="content-box fs-14">
                <div class="box flex-start" v-for="(obj,i) in commentlist" :key="i">
                    <div class="left">
                        <div class="img-box"><img v-lazy="obj.customeratturl" alt="" class="img"></div>
                    </div>
                    <div class="right flex-grow">
                        <div class="top">
                            <span class="name fs-16">{{obj.customername}}</span>
                            <span class="datetime tc-grey">{{obj.datetime}}</span>
                        </div>
                        <div class="bottom">{{obj.content}}</div>
                    </div>
                </div>
            </div>
            </happy-scroll>
        </div>
        <div class="loadmore">
            <div class="btn fs-14 tc pointer" v-show="page.page<page.pagetotal" @click="loadmore">点击加载更多</div>
        </div>
    </div>
</template>

<script>
  import {HappyScroll} from 'vue-happy-scroll'
  import 'vue-happy-scroll/docs/happy-scroll.css'
  import {mapActions, mapGetters} from 'vuex'
  import {getVedioDetailByTopic, getCommentList, updateCommentInfo, getRecommendVedioByTopic} from 'api/web-app'
  import {urlToQRCode} from 'common/js/tools.js'
  import {addPraiseInfo} from 'api/pcvideo.js'
  import {uploadCourseFavorite} from 'api/public'
  import {uploadCourseHostFollow} from 'api/api'
  export default {
    name: 'livingVideoView',
    data() {
      return {
        param: {
          kmcinnerid: this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : '',
          datacount: 3
        },
        topicid: '',
        isrecommendview: true,
        commentlist: [],
        recommendlist: [],
        item:{
          comentcount: 0,
          content: '',
          coverurl: '',
          csfileurl: '',
          datetime: '',
          description: '',
          favoritedcount: 0,
          feetype: 1,
          hostid: '',
          hostname: '',
          iscommen: 0,
          isfavorite: 0,
          isjoin: 0,
          ispraise: 0,
          kmcinnerid: '',
          praisecount: 0,
          saleprice: '',
          sharecontent: '',
          subject: '',
          uprice: '',
          viewcount: 0,
        },
        content: '',
        scrtop: 0,  // 滚动条具体顶部位置
        page: {
          page: 1,
          pagesize: 10,
          pagetotal: 0
        },
        qrcode: {
          base64: '',
          url: window.location.href
        },
        isPopView: false
      }
    },
    created() {
      if(this.domainInfo.isMobile){
        this.$router.replace({name: 'MlivingVideoView', query: {kmcinnerid: this.param.kmcinnerid}})
      }
    },
    mounted() {
      this._initView()
    },
    activated() {
      if (this.refresh) {
        this.param.kmcinnerid = this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : ''
        this._initView()
        this.setRefresh(false)
      }
    },
    methods: {
      handleComment(){
        document.body.scrollTop = this.$refs.comment.offsetTop - 60
        document.documentElement.scrollTop = this.$refs.comment.offsetTop - 60
      },
      handleZan() {
        let ispraise = this.item.ispraise == 1 ? 2 : 1
        this.setLoading(true)
        addPraiseInfo({
          data: {kmcinnerid: this.item.kmcinnerid, kmctype: 4, optype: ispraise},
          success: () => {
            this.setLoading(false)
            if (ispraise == 2) {
              this.$message.success('取消成功')
              this.item.praisecount--
              this.item.ispraise = 0
            } else {
              this.$message.success('收藏成功')
              this.item.praisecount++
              this.item.ispraise = 1
            }
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      handleCollect() {
        let isfavorite = this.item.isfavorite == 1 ? 2 : 1
        this.setLoading(true)
        uploadCourseFavorite({
          data: {optype: isfavorite, courseid: this.item.kmcinnerid, kmctype: 4},
          success: () => {
            if (isfavorite == 2) {
              this.$message.success('取消成功')
              this.item.favoritedcount--
              this.item.isfavorite = 0
            } else {
              this.$message.success('点赞成功')
              this.item.favoritedcount++
              this.item.isfavorite = 1
            }
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      handleClick(obj) {
        this.$router.push({name: 'livingVideoView', query: {kmcinnerid: obj.kmcinnerid}})
        this.param.kmcinnerid = obj.kmcinnerid
        this._initView()
      },
      _initView() {
        if (this.param.kmcinnerid) {
          this.page.page = 1
          this.isrecommendview = true
          this.isPopView = false
          this._getView()
          this._getList()
          this._getRecommendVedioByTopic()
          this.qrcode.base64 = urlToQRCode(this.qrcode.url)
        }
      },
      handleCopy() {
        var input = document.getElementById("input")
        input.select()
        document.execCommand("copy")
      },
      handleAdd() {
        if (!this.user.isLogin) {
          this.setLoginPop(true)
        } else if (!this.content.length) {
          this.$message.error('请输入讨论内容')
        } else {
          this._add()
        }
      },
      handleMore() {
        this.$router.push({name: 'livingVideoList', query: {topicid: this.item.hostid, hostname: this.item.hostname}})
      },
      goVideoList() {
        this.$router.push({name: 'livingVideoList', query: {topicid: this.item.hostid, hostname: this.item.hostname}})
      },
      openLogin() {
        this.setLoginPop(true)
      },
      loadmore() {
        this.page.page++
        this._getList()
      },
      load() {},
      handleClose() {
        this.isrecommendview = !this.isrecommendview
        if (this.isrecommendview) {
          this.$refs.recommend.style.width = '246px'
        } else {
          this.$refs.recommend.style.width = 0
        }
      },
      _getRecommendVedioByTopic() {
        this.setLoading(true)
        getRecommendVedioByTopic({
          data: Object.assign({}, this.param),
          success: data => {
            this.setLoading(false)
            this.recommendlist = data.data.content
            this.topicid = data.data.topicid
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      _add() {
        this.setLoading(true)
        updateCommentInfo({
          data: Object.assign({}, {content: this.content}, this.param),
          success: () => {
            this.setLoading(false)
            this.$message.success('发布成功')
            this.content = ''
            this.page.page = 1
            this._getList()
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      _getList(){
        this.setLoading(true)
        getCommentList({
          data: Object.assign({}, this.page, this.param),
          success: data => {
            this.setLoading(false)
            if (this.page.page == 1) {
              this.commentlist = data.data.commentinfo
            } else {
              this.commentlist = this.commentlist.concat(data.data.commentinfo)
            }
            this.page.pagetotal = data.data.pageinfo.pageCount
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      _getView(){
        this.setLoading(true)
        getVedioDetailByTopic({
          data: this.param,
          success: data => {
            this.setLoading(false)
            this.item = data.data
            document.title = this.item.subject
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      uploadCourseHostFollow() {
          if (!this.user.isLogin) {
            this.setLoginPop(true)
            return
          }
          this.setLoading(true)
          uploadCourseHostFollow({
            data: {
              hostid: this.item.hostid,
              optype: this.item.isfavoritehost === 0 ? 1 : 2
            },
            success: () => {
              this.setLoading(false)
              this.$message.success('操作成功！')
              if (this.item.isfavoritehost === 0) {
                this.item.isfavoritehost = 1
              } else {
                this.item.isfavoritehost = 0
              }
            },
            error: data => {
              this.setLoading(false)
              this.$message.error(data.msg)
            }
          })
      },
      ...mapActions(['setLoading', 'setLoginPop', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters(['user', 'refresh', 'domainInfo'])
    },
    components: {HappyScroll}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.livingVideoView {
    width: 1200px;
    margin: auto;
    padding: 20px 0;
    .video-player{
        background: #262626;
        .close-btn{
            position: absolute;
            width: 16px;
            height: 54px;
        }
        .left{
            flex-grow: 1;
            position: relative;
            .video-box{
                background: #000;
                transition: all .3s;
                .video{
                    max-width: 100%;
                    max-height: 100%;
                    min-height: 536px;
                    &:focus {
                      outline: none;
                    }
                }
            }
            .oper{
                height: 56px;
                padding: 0 10px;
                .box{
                    padding: 0 10px;
                    margin-right: 10px;
                    color:  #808080;
                    &:before{
                        width: 25px;
                        height: 25px;
                        margin-right: 6px;
                    }
                }
                .separate{
                    font-size: 14px;
                    display: inline-block;
                    color: #5C5C5C;
                    margin: 0 20px;
                }
                .left_actions {
                    .coverurl {
                      width: 30px;
                      height: 30px;
                      margin-left: 20px;
                      margin-right: 10px;
                      border-radius: 50%;
                      cursor: pointer;
                    }
                    .hostname {
                      font-size: 14px;
                      margin-right: 20px;
                      color: #fff;
                    }
                    .el-button {
                      width: 66px;
                      height: 26px;
                      padding: 0;
                      border-radius: 2px;
                      font-size: 12px;
                    }
                }
                .appTips {
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  color: #808080;
                  cursor: pointer;
                  .phone {
                    width: 25px;
                    height: 25px;
                    margin-right: 6px;
                  }
                }
            }
            .close-btn{
                top: calc(50% - 28px);
                right: 0;
                transform: rotate(180deg);
                background: url("~common/images/leveing/live-detail/close_btn.png");
            }
        }
        .right{
            width: 246px;
            height: 592px;
            transition: all .3s;
            position: relative;
            overflow: hidden;
            .recommend-box{
                position: absolute;
                width: 246px;
                height: 592px;
                box-sizing: border-box;
                top:0;
                left: 0;
                padding: 15px 30px 56px 30px;
                .title{
                    padding: 4px 0 20px 0;
                }
                .happy-scroll{
                    height: 488px;
                    width: 200px;
                    .happy-scroll-container{
                        width: 100% !important;
                        height: 488px !important;
                    }
                }
                .list{
                    .box{
                        .img-box{
                            width: 186px;
                            height: 104px;
                            margin-bottom: 5px;
                            .img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .subject{
                            line-height: 22px;
                        }
                    }
                    .box+.box{
                        margin-top: 15px;
                    }
                }
            }
            .close-btn{
                left: 0;
                top: calc(50% - 28px);
                background: url("~common/images/leveing/live-detail/close_btn.png");
            }
            .load-more{
                width: 135px;
                height: 30px;
                line-height: 30px;
                background: #409EFF;
                border-radius: 4px;
                position: absolute;
                bottom: 13px;
                left: 55px;
            }
        }
    }
    .intro{
        padding: 25px 20px;
        background: #F6F8FA;
        .subject{
            line-height: 28px;
        }
        .desc{
            line-height: 24px;
            margin-top: 6px;
            img,video{
                max-width: 100%;
            }
        }
        .datetime{
            margin-top: 15px;
        }
    }
    .living-container{
        width: 1200px;
        margin: auto;
        .title{
            padding: 30px 0 10px 0;
            line-height: 28px;
        }
    }
    .join-box{
        .content-box{
            margin-top: 10px;
            box-sizing: border-box;
        }
        .el-textarea__inner{
            width: 100%;
            border: 1px solid #E5E5E5;
            border-bottom-width: 0;
            border-radius: 0;
        }
        textarea{
            resize: none;
            width: 100%;
        }
        .oper{
            height: 50px;
            background: #F6F8FA;
            border: 1px solid #E5E5E5;
            border-top-width: 0;
            .left{
                padding: 0 20px;
            }
            .btn{
                width: 100px;
                height: 50px;
                line-height: 50px;
                background: #409EFF;
            }
        }
    }
    .comment-box{
        .happy-scroll{
            height: 650px;
            width: 1200px;
            .happy-scroll-container{
                width: 100% !important;
                height: 650px !important;
            }
        }
       .content-box{
           .box{
                padding: 20px 0;
                border-bottom: 1px solid #E5E5E5;
               .left{
                   .img-box{
                       width: 52px;
                       min-width: 52px;
                       height: 52px;
                       border-radius: 50%;
                       overflow: hidden;
                       .img{
                           width:100%;
                           height: 100%;
                       }
                   }
               }
               .right{
                   padding: 10px 10px 0 20px;
                   .top{
                       margin-bottom: 20px;
                       line-height: 22px;
                       .name{
                           margin-right: 20px;
                       }
                   }
                   .bottom{
                       line-height: 22px;
                   }
               }
           }
       }
    }
    .loadmore{
        background: #FFFFFF;
        padding-top: 30px;
        .btn{
            border: 1px solid #027AFF;
            border-radius: 4px;
            margin: auto;
            width: 200px;
            height: 40px;
            line-height: 40px;
            color: #027AFF;
        }
    }
}
.share-box{
    position: absolute;
    width: 425px;
    background: #FFFFFF;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    .icon:before{
         width: 26px;
         height: 26px;
         margin-left: 8px;
    }
    .right{
        margin-left: 20px;
    }
    .img-box{
         margin-top: 10px;
         width: 80px;
         height: 80px;
         .img{
             width: 100%;
             height: 100%;
         }
    }
    .el-input {
        width: 210px;
        .el-input__inner {
            height: 30px;
            line-height: 30px;
        }
    }
    .el-button {
        margin-left: 10px;
        width: 50px;
        height: 30px;
        padding: 0;
    }
 }
.appPopover {
  box-sizing: border-box;
  .appCode {
    text-align: center;
    font-size: 12px;
    img {
      width: 70px;
      height: 70px;
      margin: 0 auto 10px;
    }
  }
}
</style>